import { ApolloClient, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { apolloLink } from '../../../shared/data/apolloClient';

const workspacesContentApolloClient = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache({
    typePolicies: {
      Organization: {
        fields: {
          alerts: relayStylePagination(),
          groups: relayStylePagination(),
          memberships: relayStylePagination(),
          suspects: relayStylePagination(),
          vehicles: relayStylePagination(),
        },
      },
    },
  }),
});

export default workspacesContentApolloClient;
